import React from 'react';
import PropTypes from 'prop-types';

function Loader({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <circle cx="12" cy="12" r="7.35" stroke="#DADDE0" />
      <path
        d="M12 4C13.975 4 15.8802 4.73057 17.3489 6.05109C18.8175 7.3716 19.7458 9.1887 19.955 11.1526C20.1642 13.1165 19.6395 15.0884 18.482 16.6886C17.3245 18.2889 15.6159 19.4044 13.6853 19.8205L13.2604 17.849C14.7044 17.5378 15.9823 16.7035 16.848 15.5067C17.7137 14.3098 18.1061 12.835 17.9496 11.3662C17.7932 9.8974 17.0989 8.53837 16.0005 7.55075C14.9021 6.56312 13.4771 6.01672 12 6.01672L12 4Z"
        fill={stroke}
        className="animated-path"
      />
    </svg>
  );
}

Loader.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Loader;
